export const openCustomPostModule = (functionAdded,moduleOpen) => {
    if(moduleOpen===false){
         window.scrollTo({
            top: 0, // Scroll to the top
            left: 0, // Scroll to the leftmost side
        });        
        document.body.style.overflow = 'hidden';
    }
    else{
        document.body.style.overflow = '';
    }
    functionAdded((inputOpen) => (inputOpen === false ? true : false));
}